import _ from "lodash";
import retrieveUTM from "utils/UTM";
import getUrlParameter from "helpers/getUrlParameter";

const requiredKeys = [
  "categoryId",
  "title",
  "content",
  "country",
  "target",
  "termsAgreedAt",
  "paymentRecipientType",
];

export const processCampaignForm = async (storeData) => {
  const tags = retrieveUTM();

  const inputFormData = formatStoreData(storeData);

  const mappedTracking = {
    page: window.location.pathname,
    source: tags.utm_source,
    medium: tags.utm_medium,
    campaign: tags.utm_campaign,
    term: tags.utm_term,
    content: tags.utm_content,
    fbclid: tags.fbclid,
  };

  const filteredTracking = {};

  Object.entries(mappedTracking).forEach(([key, value]) => {
    if (value) {
      filteredTracking[key] = value;
    }
  });
  let meta = null;
  const gid = getUrlParameter("gid");
  if (gid) {
    meta = [{ key: "google_client_id", value: gid }];
  }

  const mappedFormData = {
    categoryId: inputFormData.category,
    title: inputFormData.campaign_title,
    content: inputFormData.content,
    country: inputFormData.country,
    paymentRecipientType: inputFormData.paymentRecipientType,
    termsAgreedAt: inputFormData.termsAgreedAt ? new Date().toISOString() : null,
    target: {
      amount: _.round(inputFormData.amount),
      currency: inputFormData.currency,
    },
    tracking: filteredTracking,
    meta,
  };

  const userData = {
    name: `${inputFormData.firstName} ${inputFormData.lastName}`,
    email: inputFormData.email,
  };

  if (inputFormData.password && inputFormData.password === inputFormData.password_confirmation) {
    userData.password = inputFormData.password;
  }

  const { error, formDataValid } = await new Promise((resolve) => {
    resolve(validateData(mappedFormData));
  });

  return {
    mappedFormData,
    userData,
    formDataValid,
    error,
  };
};

const formatStoreData = (storeData) => {
  const formatData = [];
  storeData.fields.forEach((field) => {
    formatData[field.name] = field.value;
  });
  return formatData;
};

const validateData = (data) => {
  let error;
  let formDataValid = true;
  Object.keys(data).forEach((key) => {
    if (!data[key] && requiredKeys.includes(data[key])) {
      error = `${key} has not been supplied`;
      formDataValid = false;
    }
  });
  return {
    error,
    formDataValid,
  };
};
